<template>
    <div class="seller-details-seller">
        <div> <p><strong>Closing Date:</strong> {{ this.closingDate || 'Not Set' }}</p> </div>
        <b-button
            class="btn-sm gold-button"
            @click="$bvModal.show('closing-information-modal')"
        >
            Add Closing Information
        </b-button>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import {getUTCDate} from '@helpers/dates';
export default {
    name: 'ClosingInformationDetails',
    props: {
        orderAppResource: {
            type: Object,
        },
    },
    computed: {
        closingDate() {
            return this.orderAppResource.closingDate ? dayjs(getUTCDate(this.orderAppResource.closingDate)).format('MM/DD/YYYY') : '';
        },
    },
}
</script>
